<template>
  <div class="inheritable-value" :class="{ 'inheritable-value--inherited': isInherited }">
    <slot v-if="isBlank" name="empty">
      <text-placeholder />
    </slot>
    <slot v-else name="value" :value="presentValue" :inherited="isInherited">
      <slot v-if="isInherited" name="inherited">{{ inheritedValue }}</slot>
      <slot v-else name="overridden">
        <slot v-if="isDate">
          {{ valueAsDate }}
        </slot>
        <slot v-else>
          {{ value }}
        </slot>
      </slot>
    </slot>
  </div>
</template>

<script>
import { isNull, isUndefined } from 'lodash';
import TextPlaceholder from '@/components/TextPlaceholder';

function isBlank(value) {
  return isNull(value) || isUndefined(value);
}

export default {
  name: 'inheritable-value',
  components: {
    TextPlaceholder,
  },
  props: {
    value: null,
    inheritedValue: null,
    isDate: false,
  },
  computed: {
    isBlank() {
      return isBlank(this.value) && isBlank(this.inheritedValue);
    },
    isInherited() {
      return isBlank(this.value) && !isBlank(this.inheritedValue);
    },
    presentValue() {
      if (this.isInherited) return this.inheritedValue;
      return this.value;
    },
    valueAsDate() {
      const date = new Date(this.value);
      const optionsWithTime = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      };

      return date.toLocaleDateString('de', optionsWithTime);
    },
  },
};
</script>

<style lang="scss" scoped>
.inheritable-value--inherited {
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// InheritableValue.vue?10253539